'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import {
  getPendingRouteSkeleton,
  isSettingsInternalNavigation,
} from '~/components/Navigation/getPendingRouteSkeleton';
import { usePendingHref } from '~/components/Navigation/routeNavigationStore';

/**
 * Instant content swap on soft navigation: show a shape-matched skeleton on
 * click instead of leaving the previous screen up until the route catches up.
 * Settings-internal nav is left to SettingsShell.
 */
export function WorkspaceContentPane({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const pendingHref = usePendingHref();

  const showPending =
    !!pendingHref &&
    pendingHref !== pathname &&
    !isSettingsInternalNavigation(pathname, pendingHref);

  if (showPending && pendingHref) {
    return <>{getPendingRouteSkeleton(pendingHref)}</>;
  }

  return <>{children}</>;
}
